export default __webpack_public_path__ + "static/media/logoJobllegro.c8031943.svg";